export const slideToggleDefaults = {
  miliseconds: 200,
};
